import React, { memo } from "react";

import { cacheTypes } from "../../../constants/cacheTypes";

interface TypeColumnProps {
  type: string;
}

const TypeColumn: React.FC<TypeColumnProps> = memo(({ type }) => {
  if (cacheTypes[type]) {
    return <div className="typed-column">{cacheTypes[type]}</div>;
  }
  return null;
});

export { TypeColumn };
